import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import firebase from 'firebase';
// import VModal from 'vue-js-modal'
import VueTextareaAutosize from 'vue-textarea-autosize';
// import {userId} from './const'
// import '@babel/polyfill'
// import 'babel-polyfill';

Vue.use(VueTextareaAutosize);

Vue.config.productionTip = false;

// Vue.use(VModal, { dynamic: true })

// //서버연결
// const Config = {
//   apiKey: "AIzaSyA2lE8La-cRRtdP81CHChdVPTM7gTZMhvw",
//   authDomain: "voice-of-maxst.firebaseapp.com",
//   databaseURL: "https://voice-of-maxst.firebaseio.com",
//   projectId: "voice-of-maxst",
//   storageBucket: "voice-of-maxst.appspot.com",
//   messagingSenderId: "283032408241",
//   appId: "1:283032408241:web:36bc057db178ad10a1d290",
//   measurementId: "G-61TCB6CVXQ"
// };
// firebase.initializeApp(Config);

const Config = {
  apiKey: 'AIzaSyAQApZyB4il4pUYKOhgfrz871fPWJKsmS8',
  authDomain: 'voiceofmaxst-78bd4.firebaseapp.com',
  databaseURL: 'https://voiceofmaxst-78bd4.firebaseio.com',
  projectId: 'voiceofmaxst-78bd4',
  storageBucket: 'voiceofmaxst-78bd4.appspot.com',
  messagingSenderId: '634849914671',
  appId: '1:634849914671:web:c0838269168397bca83bda',
  measurementId: 'G-32K5LQ5JVV',
};

// if (firebase.messaging.isSupported()) {
//   firebase.initializeApp(Config);
// }

firebase.initializeApp(Config);

if (!localStorage.getItem('userId'))
  //userId 저장 //localstorage에서 삭제하면 새로 들어감
  localStorage.setItem('userId', guid());

//푸시알람을 위한 설정
// const messaging = firebase.messaging();
// messaging.usePublicVapidKey("BNPI8IubZlsafCp6YiVjZKp2zMXHhpYiCriqWuhYK02pzYHSriiA4lru8h2DyLmaGcYLqHm9Z-C6H5TV1ONxRb0"); // 1. 새 키 페어 생성
if (firebase.messaging.isSupported()) {
  const messaging = firebase.messaging();
  messaging.usePublicVapidKey(
    'BNbfCgB0SdaVLwKUuEmPOXVanoFq8esAFxyLo1rPYJqlL1aC4m-rZHfSw0Mn8yD_QREYCm0V5POVOWEouw8d2pU',
  ); // 1. 새 키 페어 생성

  // 알림 권한 요청
  messaging
    .requestPermission()
    .then(() => {
      console.log('Notification permission granted.');

      // 토큰받아오기
      messaging.getToken().then(token => {
        if (!localStorage.getItem('token')) {
          //localstorage에 없으면 1.처음 접속 2.지움(앞에꺼 못지워도 어쩔수없음)
          firebase
            .database()
            .ref('user/')
            .push(token);
          localStorage.setItem('token', token);
        } else {
          //localstorage에 있으면 1.접속한적있고 변화없음 2.알람 끄고 다시 허용 3.user 테이블에 없음(테스트)
          var t = false;
          firebase
            .database()
            .ref('user')
            .once('value', snapshot => {
              snapshot.forEach(childSnapshot => {
                var childData = childSnapshot.val();
                if (childData === token) {
                  //리스트에 이미 있으면 아무일도 일어나지 않음(1번)
                  t = true;
                }
              });
              if (t === false) {
                //리스트에 없으면(2번(앞에꺼 못지우고 쌓임), 3번)
                firebase
                  .database()
                  .ref('user/')
                  .push(token);
                localStorage.setItem('token', token);
              }
            });
        }
      });
    })
    .catch(err => {
      console.log('Unable to get permission to notify.', err);
    });
}

function guid() {
  function s4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app');
